import BaseModel from './base-model';
/**
 * format:
 * @COMMON_NAME: "Tecnico"
 * @REL_ATTR: "1000122"
 * @id: "1000122"
 */
export default class Position extends BaseModel {
  constructor(opts = {}) {
    super(opts);
  }
}
